import httpClient from "../../../../api/httpClient"

const PARTS_LIST_UPLOAD_ENDPOINT = "/kiban/api/parts-procurement/upload"
const PARTS_LIST_FILE_INFO_ENDPOINT = "/kiban/api/parts-procurement/file-info"

export type PartsListUploadResponse = {
  localStorageMapkey: string
}
export type PartsListFileInfoResponse = {
  fileName: string
}

const partsListApi = {
  async upload(file: File) {
    const formData = new FormData()
    formData.append("bomFile", file)

    return httpClient.post<PartsListUploadResponse>(PARTS_LIST_UPLOAD_ENDPOINT, formData)
  },
  async fileInfo(localStorageMapkey: string) {
    return httpClient.get<PartsListFileInfoResponse>(PARTS_LIST_FILE_INFO_ENDPOINT, {
      queryParams: { localStorageMapkey },
    })
  },
} as const

export default partsListApi
